import { TimeService } from '@adaptiva/core/common';
import * as Math2 from '@adaptiva/core/math';
import { provideBaseWidget } from '@adaptiva/core/widgets';
import { BaseEditorError, EEditorErrorType, IBaseEditorError, Schedule } from '@adaptiva/data-service';
import { ITimeScaleConfiguration, TimeScaleConfiguration, TimeScaleUnit } from '@adaptiva/widgets/time-scale';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseScheduleTypeComponent } from '../base-schedule-type.component';

@Component({
	standalone: false,
	selector: 'app-recurring-by-interval',
	templateUrl: './recurring-by-interval.component.html',
	providers: [provideBaseWidget(() => RecurringByIntervalComponent)],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecurringByIntervalComponent extends BaseScheduleTypeComponent {

	protected readonly executionTimeScaleConfig: ITimeScaleConfiguration = {
		format: TimeScaleConfiguration.SCALE_MILLISECONDS,
		scaleUnits: [
			new TimeScaleUnit('days', 0, Math2.INT_MAX),
			new TimeScaleUnit('hours'),
			new TimeScaleUnit('minutes'),
		]
	};

	public validate(): IBaseEditorError[] {
		const _errors: IBaseEditorError[] = [];

		if (!+this.schedule.recurrenceIntervalInMilliseconds || +this.schedule.recurrenceIntervalInMilliseconds < 1) {
			_errors.push(
				new BaseEditorError(
					EEditorErrorType.Error,
					this.guid,
					['RecurringIntervalDurationInput', 'Interval must be greater than 0']
				)
			);
		}

		return _errors;
	}

	public override commitModelToView(): void {
		return;
	}

	private _calculateIntervalUnit(_milliseconds: number): Schedule.EIntervalUnits {
		if (_milliseconds >= TimeService.oneDay)
			return Schedule.EIntervalUnits.DAYS;
		else if (_milliseconds >= TimeService.oneHour)
			return Schedule.EIntervalUnits.HOURS;
		else
			return Schedule.EIntervalUnits.MINUTES;
	}

	public setTimeScale(_event: number): void {
		this.outputChanges([
			{ propertyName: 'recurrenceIntervalInMilliseconds', value: _event },
			{ propertyName: 'unitOfRecurrenceIntervalDuration', value: this._calculateIntervalUnit(_event) },
		]);
	}
	// event listeners end

}
